/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import type { ImageFragment } from 'bundles/ent-website/__generated__/contentfulTypes';

type Props = {
  content: ImageFragment;
  width?: number | string;
  height?: number | string;
  shape?: 'square' | 'circle' | 'rounded';
  isBackground?: boolean;
};

function Image({ width, height, content, shape = 'square', isBackground = false, ...otherProps }: Props) {
  if (!content.url) {
    return null;
  }

  if (isBackground) {
    return (
      <div
        css={{
          backgroundImage: `url(${content.url})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          width: '100%',
          height: '100%',
        }}
      />
    );
  }

  let actualWidth: number | string | undefined;
  let actualHeight: number | string | undefined;

  if (width !== undefined || height !== undefined) {
    actualWidth = width;
    actualHeight = height;
  } else {
    actualWidth = content.width ?? undefined;
    actualHeight = content.height ?? undefined;
  }

  let borderRadius = '0';
  if (shape === 'circle') {
    borderRadius = '50%';
  } else if (shape === 'rounded') {
    borderRadius = '25%';
  }

  return (
    <img
      src={content.url ?? ''}
      alt={content.title ?? ''}
      width={actualWidth}
      height={actualHeight}
      css={{ borderRadius }}
      {...otherProps}
    />
  );
}

export default Image;
